import React from 'react';

import PropTypes from 'prop-types';

import { Box } from '@wds/box';
import { IconCaretDown, IconSearch } from '@wds/icons';
import { Button } from '@wds/button';
import { Input } from '@wds/input';
import { InputGroup, InputGroupAddon } from '@wds/input-group';
import { Menu } from '@wds/menu';
import { Select } from '@wds/select';
import { Typography } from '@wds/typography';

export default function ReviewsTableToolbar(props) {
	const {
		canEdit,
		clearSelectedReviews,
		downloadSelectedApplications,
		downloadSelectedReviews,
		exportSelectedReviews,
		filterIncomplete,
		handleFilterIncomplete,
		handleSearch,
		numSelected,
		searchQuery,
	} = props;
	const actionMenuDisabled = numSelected <= 0;

	return (
		<Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
			<Box display="flex" alignItems="center">
				<Menu
					direction="south-east"
					dense
					menuTrigger={(
						<Button
							data-testid="sma-automation-actions-button"
							color="secondary"
							disabled={actionMenuDisabled}
						>
							{gettext('Actions')}
							<IconCaretDown />
						</Button>
					)}
				>
					<React.Fragment>
						{ canEdit
						&& (
							<Menu.Item
								data-testid="sma-automation-clear-reviews"
								onClick={() => clearSelectedReviews()}
							>
								{ gettext('Clear Reviews') }
							</Menu.Item>
						)}
					</React.Fragment>
					<Menu.Item
						data-testid="sma-automation-download-applications"
						onClick={() => downloadSelectedApplications()}
					>
						{ gettext('Download applications') }
					</Menu.Item>
					<Menu.Item
						data-testid="sma-automation-download-reviews"
						onClick={() => downloadSelectedReviews()}
					>
						{ gettext('Download my reviews') }
					</Menu.Item>
					<Menu.Item
						data-testid="sma-automation-export-all-reviews"
						onClick={() => exportSelectedReviews()}
					>
						{ gettext('Export all reviews (PDF)') }
					</Menu.Item>
				</Menu>
				<Box ml={2} data-testid="sma-automation-selected-count">
					<Typography>{interpolate(gettext('%(numSelected)s selected'), { numSelected }, true)}</Typography>
				</Box>
			</Box>
			<Box display="flex" alignItems="center">
				<Select
					id="filterIncomplete"
					onChange={handleFilterIncomplete}
					value={filterIncomplete}
				>
					<Select.Option value="0">{gettext('All applications')}</Select.Option>
					<Select.Option value="1">{gettext('Incomplete reviews')}</Select.Option>
				</Select>
				<Box ml={3}>
					<InputGroup>
						<InputGroupAddon><IconSearch /></InputGroupAddon>
						<Input
							value={searchQuery}
							onChange={handleSearch}
							placeholder={gettext('Search...')}
						/>
					</InputGroup>
				</Box>
			</Box>
		</Box>
	);
}

ReviewsTableToolbar.propTypes = {
	canEdit: PropTypes.bool,
	handleSearch: PropTypes.func,
	searchQuery: PropTypes.string.isRequired,
	numSelected: PropTypes.number.isRequired,
	downloadSelectedApplications: PropTypes.func.isRequired,
	downloadSelectedReviews: PropTypes.func.isRequired,
	clearSelectedReviews: PropTypes.func.isRequired,
	exportSelectedReviews: PropTypes.func.isRequired,
	handleFilterIncomplete: PropTypes.func.isRequired,
	filterIncomplete: PropTypes.number.isRequired,
};

ReviewsTableToolbar.defaultProps = {
	canEdit: false,
	handleSearch: () => {},
};
